export interface Manga {
  slug: string;
  title: string;
  cover: string;
  category: string;
  categoryName: string;
  tags: string[];
  rating: number;
  popular: number;
  status: string;
  chapters: number;
  author: string;
  year: string;
  intro: string;
}

export const mangas: Manga[] = [
  {
    slug: "huoyan-zhanshi",
    title: "烈焰战士",
    cover:
      "https://readdy.ai/api/search-image?query=heroic%20manga%20book%20cover%20of%20a%20young%20warrior%20wreathed%20in%20blazing%20orange%20flames%20holding%20a%20glowing%20sword%2C%20dynamic%20dynamic%20composition%2C%20bold%20warm%20orange%20and%20red%20palette%2C%20stylized%20shonen%20anime%20artwork%2C%20clean%20dark%20background%20with%20embers&width=600&height=800&seq=manga-01&orientation=portrait",
    category: "rexue-maoxian",
    categoryName: "热血冒险",
    tags: ["热血", "战斗", "成长"],
    rating: 9.2,
    popular: 98200,
    status: "连载中",
    chapters: 236,
    author: "火炎社",
    year: "2020",
    intro:
      "少年阿焰背负着守护村庄的使命踏上修行之路，在一次次生死战斗之中觉醒血脉力量，誓要成为最强的烈焰战士，击败席卷大地的黑暗势力。",
  },
  {
    slug: "xingchen-luoxue",
    title: "星辰落雪",
    cover:
      "https://readdy.ai/api/search-image?query=romantic%20manga%20book%20cover%20of%20a%20boy%20and%20girl%20standing%20under%20a%20starlit%20snowy%20sky%2C%20gentle%20soft%20peach%20and%20warm%20white%20tones%2C%20tender%20sweet%20atmosphere%2C%20stylized%20romance%20anime%20artwork%2C%20clean%20soft%20background&width=600&height=800&seq=manga-02&orientation=portrait",
    category: "lianai-yanqing",
    categoryName: "恋爱言情",
    tags: ["恋爱", "校园", "纯爱"],
    rating: 8.8,
    popular: 76100,
    status: "已完结",
    chapters: 128,
    author: "雪夜工作室",
    year: "2019",
    intro:
      "那个总是迟到的少年，和那个永远坐在窗边的少女，在漫天星辰落雪的城市里，展开一段关于暗恋、告白与双向奔赴的温柔恋爱故事。",
  },
  {
    slug: "jumu-dashi",
    title: "举目大师",
    cover:
      "https://readdy.ai/api/search-image?query=mystery%20manga%20book%20cover%20of%20a%20sharply%20dressed%20detective%20with%20magnifying%20glass%20in%20front%20of%20an%20enigmatic%20city%20skyline%2C%20dramatic%20amber%20and%20deep%20teal%20contrast%2C%20stylized%20mystery%20anime%20artwork%2C%20clean%20noir%20background&width=600&height=800&seq=manga-03&orientation=portrait",
    category: "xuanyi-tuili",
    categoryName: "悬疑推理",
    tags: ["推理", "悬疑", "烧脑"],
    rating: 9.0,
    popular: 65400,
    status: "连载中",
    chapters: 89,
    author: "谜题社",
    year: "2021",
    intro:
      "天才侦探举目破获一桩桩匪夷所思的悬案，每一次真相背后都隐藏着更大的阴谋，正义与罪恶的较量在迷雾笼罩的城市中持续上演。",
  },
  {
    slug: "jiuxiao-jianchen",
    title: "九霄剑尘",
    cover:
      "https://readdy.ai/api/search-image?query=xianxia%20manga%20book%20cover%20of%20a%20young%20swordsman%20with%20a%20flowing%20immortal%20robe%20riding%20a%20flying%20sword%20among%20golden%20clouds%2C%20warm%20gold%20and%20jade%20palette%2C%20epic%20cultivation%20atmosphere%2C%20stylized%20xianxia%20anime%20artwork%2C%20clean%20heavenly%20background&width=600&height=800&seq=manga-04&orientation=portrait",
    category: "xuanhuan-xiuxian",
    categoryName: "玄幻修仙",
    tags: ["修仙", "剑道", "玄幻"],
    rating: 9.4,
    popular: 120300,
    status: "连载中",
    chapters: 342,
    author: "青云剑阁",
    year: "2018",
    intro:
      "一介废柴少年意外获得上古剑诀，自此踏入九霄之巅的修仙大道，一路斩妖除魔、问鼎剑道，谱写属于自己的不朽传奇。",
  },
  {
    slug: "jijia-junzhu",
    title: "机甲君主",
    cover:
      "https://readdy.ai/api/search-image?query=sci-fi%20mecha%20manga%20book%20cover%20of%20a%20colossal%20war%20robot%20with%20glowing%20orange%20core%20facing%20a%20star%20battlefield%2C%20warm%20orange%20and%20steel%20tones%2C%20epic%20scale%2C%20stylized%20mecha%20anime%20artwork%2C%20clean%20space%20background&width=600&height=800&seq=manga-05&orientation=portrait",
    category: "kehuan-jijia",
    categoryName: "科幻机甲",
    tags: ["科幻", "机甲", "星际"],
    rating: 8.9,
    popular: 59800,
    status: "连载中",
    chapters: 156,
    author: "星核动力",
    year: "2020",
    intro:
      "在资源枯竭的星际时代，少年驾驶着父亲遗留的神秘机甲，踏上寻找失落家园的征途，成为纵横星海的机甲君主。",
  },
  {
    slug: "mengxiu-riji",
    title: "萌系日常",
    cover:
      "https://readdy.ai/api/search-image?query=cute%20comedy%20manga%20book%20cover%20of%20several%20adorable%20chibi%20characters%20with%20funny%20expressions%20gathered%20together%2C%20bright%20cheerful%20warm%20yellow%20and%20peach%20palette%2C%20playful%20stylized%20slice%20of%20life%20anime%20artwork%2C%20clean%20light%20background&width=600&height=800&seq=manga-06&orientation=portrait",
    category: "gaoxiao-richang",
    categoryName: "搞笑日常",
    tags: ["搞笑", "日常", "治愈"],
    rating: 8.6,
    popular: 44700,
    status: "连载中",
    chapters: 210,
    author: "小灯泡社",
    year: "2021",
    intro:
      "一群性格迥异的萌系小伙伴的爆笑日常，沙雕剧情与暖心片段轮番上演，让人笑到停不下来又忍不住感到治愈。",
  },
  {
    slug: "lanshan-fengwang",
    title: "篮场风王",
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20sports%20manga%20book%20cover%20of%20a%20determined%20teenage%20basketball%20player%20jumping%20for%20a%20slam%20dunk%20with%20intense%20focus%2C%20dynamic%20warm%20orange%20lighting%20and%20motion%20lines%2C%20stylized%20sports%20anime%20artwork%2C%20clean%20gym%20background&width=600&height=800&seq=manga-07&orientation=portrait",
    category: "yundong-jingji",
    categoryName: "运动竞技",
    tags: ["篮球", "竞技", "青春"],
    rating: 8.7,
    popular: 52100,
    status: "已完结",
    chapters: 188,
    author: "灌篮工作室",
    year: "2017",
    intro:
      "曾经被戏称为「球场软脚虾」的少年，凭借一腔热血与不懈努力，一步步成长为球队的灵魂人物，在篮场上书写属于自己的传奇。",
  },
  {
    slug: "mofa-xiaoyuan",
    title: "魔法学院",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20magic%20school%20manga%20book%20cover%20of%20a%20young%20mage%20student%20holding%20a%20staff%20surrounded%20by%20glowing%20golden%20spell%20rune%20circles%2C%20warm%20amber%20and%20soft%20violet%20magic%20light%2C%20stylized%20fantasy%20anime%20artwork%2C%20clean%20magical%20background&width=600&height=800&seq=manga-08&orientation=portrait",
    category: "qihuan-mofa",
    categoryName: "奇幻魔法",
    tags: ["魔法", "学院", "奇幻"],
    rating: 9.1,
    popular: 88900,
    status: "连载中",
    chapters: 174,
    author: "星光魔法社",
    year: "2022",
    intro:
      "天赋异禀却魔法失控的少女，进入神秘的皇家魔法学院，在这里结识伙伴、解开身世之谜，成长为能够守护世界的强大魔法师。",
  },
  {
    slug: "yinyue-guanzhe",
    title: "阴夜观察者",
    cover:
      "https://readdy.ai/api/search-image?query=creepy%20horror%20manga%20book%20cover%20of%20a%20hooded%20observer%20holding%20a%20lantern%20in%20a%20dark%20misty%20forest%20at%20night%2C%20dim%20deep%20amber%20candlelight%20and%20black%20shadows%2C%20stylized%20horror%20anime%20artwork%2C%20clean%20dark%20background&width=600&height=800&seq=manga-09&orientation=portrait",
    category: "kongbu-lingyi",
    categoryName: "恐怖灵异",
    tags: ["恐怖", "灵异", "都市"],
    rating: 8.5,
    popular: 33800,
    status: "连载中",
    chapters: 96,
    author: "子夜社",
    year: "2021",
    intro:
      "一位能看见灵体的青年，在深夜的城市中观察并处理那些游荡的灵魂，每一个故事背后都藏着一段令人脊背发凉的往事。",
  },
  {
    slug: "xiyang-gushi",
    title: "夏阳时光",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20school%20youth%20manga%20book%20cover%20of%20a%20group%20of%20high%20school%20friends%20standing%20under%20a%20warm%20golden%20sunset%20in%20a%20schoolyard%2C%20soft%20warm%20yellow%20and%20amber%20tones%2C%20stylized%20youth%20anime%20artwork%2C%20clean%20bright%20background&width=600&height=800&seq=manga-10&orientation=portrait",
    category: "xiaoyuan-qingchun",
    categoryName: "校园青春",
    tags: ["校园", "青春", "友情"],
    rating: 8.8,
    popular: 61200,
    status: "已完结",
    chapters: 142,
    author: "夏日蝉鸣社",
    year: "2018",
    intro:
      "在蝉鸣不断的盛夏校园里，一群少年少女用汗水与欢笑编织青春，记录下那些关于梦想、友情与成长的闪亮时光。",
  },
  {
    slug: "kuangquan-tiexin",
    title: "狂拳铁心",
    cover:
      "https://readdy.ai/api/search-image?query=intense%20martial%20arts%20manga%20book%20cover%20of%20a%20muscular%20fighter%20with%20steel%20resolve%20and%20glowing%20orange%20aura%20throwing%20a%20punch%2C%20explosive%20warm%20red%20and%20orange%20energy%2C%20stylized%20fighting%20anime%20artwork%2C%20clean%20dark%20background&width=600&height=800&seq=manga-11&orientation=portrait",
    category: "rexue-maoxian",
    categoryName: "热血冒险",
    tags: ["格斗", "热血", "成长"],
    rating: 8.4,
    popular: 38900,
    status: "连载中",
    chapters: 112,
    author: "铁拳社",
    year: "2022",
    intro:
      "背负血仇的少年踏入地下格斗场，用一双铁拳打出一片天地，在血与火的磨砺中守护自己珍视的一切。",
  },
  {
    slug: "qingge-chuanshuo",
    title: "情歌传说",
    cover:
      "https://readdy.ai/api/search-image?query=emotional%20romance%20manga%20book%20cover%20of%20a%20young%20woman%20holding%20a%20microphone%20under%20warm%20stage%20spotlights%2C%20soft%20peach%20and%20rose%20tones%2C%20dreamy%20stylized%20romance%20anime%20artwork%2C%20clean%20stage%20background&width=600&height=800&seq=manga-12&orientation=portrait",
    category: "lianai-yanqing",
    categoryName: "恋爱言情",
    tags: ["音乐", "恋爱", "治愈"],
    rating: 8.9,
    popular: 70500,
    status: "连载中",
    chapters: 118,
    author: "旋律社",
    year: "2020",
    intro:
      "一支濒临解散的校园乐队，因为一个热爱唱歌的女孩重新出发。音乐与心动交织，谱写成一首关于青春与梦想的情歌传说。",
  },
  {
    slug: "heian-tuwei",
    title: "黑暗突围",
    cover:
      "https://readdy.ai/api/search-image?query=thriller%20manga%20book%20cover%20of%20a%20stealthy%20figure%20holding%20a%20gun%20silhouetted%20against%20an%20urban%20night%20with%20amber%20city%20lights%2C%20dramatic%20high%20contrast%20warm%20and%20cool%20tones%2C%20stylized%20action%20anime%20artwork%2C%20clean%20dark%20background&width=600&height=800&seq=manga-13&orientation=portrait",
    category: "xuanyi-tuili",
    categoryName: "悬疑推理",
    tags: ["动作", "悬疑", "都市"],
    rating: 8.7,
    popular: 47600,
    status: "连载中",
    chapters: 103,
    author: "暗影社",
    year: "2019",
    intro:
      "身怀绝技的特工在一次任务中失忆，在被追杀的绝境中逐步拼凑真相，突破层层黑暗包围，揭开隐藏多年的惊天阴谋。",
  },
  {
    slug: "xianling-guji",
    title: "仙灵古纪",
    cover:
      "https://readdy.ai/api/search-image?query=ethereal%20cultivation%20manga%20book%20cover%20of%20a%20female%20cultivator%20surrounded%20by%20glowing%20golden%20spirit%20orbs%20and%20ancient%20rune%20circles%2C%20warm%20gold%20and%20jade%20tones%2C%20mystical%20stylized%20xianxia%20anime%20artwork%2C%20clean%20spiritual%20background&width=600&height=800&seq=manga-14&orientation=portrait",
    category: "xuanhuan-xiuxian",
    categoryName: "玄幻修仙",
    tags: ["修仙", "仙侠", "女强"],
    rating: 9.0,
    popular: 83400,
    status: "连载中",
    chapters: 289,
    author: "仙灵阁",
    year: "2020",
    intro:
      "天才少女坠入轮回，携上古仙灵记忆重修一世，以一手精妙仙术横扫修真界，重写属于自己的仙灵古纪。",
  },
  {
    slug: "weilai-bianyu",
    title: "未来编年",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20manga%20book%20cover%20of%20a%20cybernetic%20android%20walking%20through%20a%20neon%20future%20city%20street%2C%20warm%20orange%20and%20gold%20neon%20highlights%2C%20stylized%20sci-fi%20anime%20artwork%2C%20clean%20future%20background&width=600&height=800&seq=manga-15&orientation=portrait",
    category: "kehuan-jijia",
    categoryName: "科幻机甲",
    tags: ["未来", "科幻", "AI"],
    rating: 8.6,
    popular: 41300,
    status: "连载中",
    chapters: 87,
    author: "未来纪元社",
    year: "2022",
    intro:
      "在人工智能高度发达的近未来，一位拥有情感的机器人调查员，在冰冷的机械都市中追寻「人性」的真正意义。",
  },
  {
    slug: "tianmi-liushi",
    title: "甜蜜旅途",
    cover:
      "https://readdy.ai/api/search-image?query=heartwarming%20food%20manga%20book%20cover%20of%20a%20cheerful%20young%20cook%20holding%20a%20steaming%20dish%20at%20a%20cozy%20street%20stall%20at%20dusk%2C%20appetizing%20warm%20amber%20and%20golden%20tones%2C%20stylized%20slice%20of%20life%20anime%20artwork%2C%20clean%20cozy%20background&width=600&height=800&seq=manga-16&orientation=portrait",
    category: "gaoxiao-richang",
    categoryName: "搞笑日常",
    tags: ["美食", "治愈", "日常"],
    rating: 8.8,
    popular: 55800,
    status: "已完结",
    chapters: 164,
    author: "深夜食堂社",
    year: "2019",
    intro:
      "辞去都市工作的青年回到故乡，开起一间深夜小食摊，用一道道温暖的料理治愈每位过路人的疲惫与孤独，也找回自己生活的意义。",
  },
];